import * as accountApi from '@/network/api/accounts.api.js'
import * as batchfileApi from '@/network/api/batchfile.api.js'
import * as beneficiariesApi from '@/network/api/transfers/beneficiaries.api.js'
import * as transfersApi from '@/network/api/transfers/transfers.api.js'
import * as apiFavorites from '@/network/api/favorites.api.js'

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCES', data)
    }
    return res
}

/** Requests Batchfile Transfer List
@return {promise} - Batchfile Transfer List
*/
export const requestBatchfileTransfersList = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileTransfersList(payload)
    if (res) context.commit('SAVE_BATCH_FILE_TRANFER_LIST', { pageNumber: payload.pageNumber, data: res.data.data })

    return res
}

/** Get BatchFileTransfer Detail
@return { promise } BatchFileTransfer Detail request
*/
export const requestBatchfileTransferDetail = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileTransferDetail(payload)

    return res
}

/** Requests Batchfile Files Types List
@return {promise} - Batchfile Files Types List request
*/
export const requestBatchfileFilesTypes = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileFilesTypes(payload)
    if (res) context.commit('SAVE_BATCH_FILES_TYPES_LIST', res.data.data)

    return res
}

/** Get Iban Information
@return { promise } Iban Information
*/
export const requestIbanInformation = async (context, payload) => {
    const res = await batchfileApi.requestIbanInformation(payload)

    return res
}

/** Requests Transfers List
@return { promise } - Transfers list request
*/
export const requestTransfersList = async (context, payload) => {
    const res = await transfersApi.getRecurringTransfersList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_TRANSFERS_LIST', data)
    }
    return res
}

/** requests favorites list
@payload { Object }
@return { promise } -  favorites list request
*/
export const requestFavoritesList = async (context, payload) => {
    const res = await apiFavorites.getFavoritesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_FAVORITES_LIST', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/** requests Operation Types
@payload { Object }
@return { promise } -  Operation Types request
*/
export const requestBatchfileOperationTypes = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileOperationTypes(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_OPERATION_TYPES', data)
    }
    return res
}

/** Submit Batchfile XLS
@payload { Object }
@return { promise } -  BatchFile Entries
*/
export const submitBatchfileXLS = async (context, payload) => {
    const res = await batchfileApi.submitBatchfileXLS(payload)
    return res
}

/** requests Batchfile Transaction Types
@return {promise} - Batchfile Transaction Types request
*/
export const requestBatchfileTransactionTypes = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileTransactionTypes(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_BATCHFILE_TRANSACTION_TYPES', data)
    }
    return res
}

/** requests Batchfile Motives
@return {promise} - Batchfile Motives request
*/
export const requestBatchfileMotives = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileMotives(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_BATCHFILE_MOTIVES', data)
    }
    return res
}

/** requests Batchfile Categories
@return {promise} - Batchfile Categories request
*/
export const requestBatchfileCategories = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileCategories(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_BATCHFILE_CATEGORIES', data)
    }
    return res
}

/** Submit Manual Batchfile Header
@payload { Object }
@return { promise } -  Manual Batchfile Header
*/
export const submitManualBatchFileHeader = async (context, payload) => {
    const res = await batchfileApi.submitManualBatchFileHeader(payload)
    return res
}

/** Submit Manual Batchfile Entries
@payload { Object }
@return { promise } -  Manual Batchfile Entries
*/
export const submitManualBatchFileEntries = async (context, payload) => {
    const res = await batchfileApi.submitManualBatchFileEntries(payload)
    return res
}

/** Request Aproval of BatchFile Transfer
@payload { Object }
@return { promise } -  Aproval of BatchFile Transfer
*/
export const aproveBatchfileTranfer = async (context, payload) => {
    const res = await batchfileApi.aproveBatchfile(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
